<script setup>
import Drawer from "./Drawer.vue"
import Modal from "./Modal.vue"
import {useBaseStore} from "~/stores/base";

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const isShowModalPremiumIntroduce = computed(() => useBaseStore().getterIsShowModalPremiumIntroduce)
const premiumTextArr = computed(() => useBaseStore().getterAppInit.ruleList.pdpRuleList.premium)

/** methods **/
const handleClose = () => {
  useBaseStore().updateIsShowModalPremiumIntroduce(false)
}
</script>

<template>
  <div class="modal-premium-introduce-mobile" v-if="isMobile">
    <Drawer :open="isShowModalPremiumIntroduce" :position="'bottom'" :border-radius="'15px 15px 0 0'" :z-index="4" @close="handleClose">
      <div class="modal-premium-introduce">
        <img class="close" src="@/assets/img/icon-close-black.svg" alt="close" @click.stop="handleClose">

        <div class="subtitle">Rent Premium with your monthly subscription</div>
        <div class="title">Premiums Styles</div>
        <div class="text">
          <span v-for="(item, index) in premiumTextArr" :key="index">{{item}}</span>
        </div>
      </div>
    </Drawer>
  </div>
  <div class="modal-premium-introduce-desktop" v-else>
    <Modal :open="isShowModalPremiumIntroduce" @close="handleClose" z-index="4" :border-radius="'15px 15px 15px 15px'">
      <div class="modal-premium-introduce">
        <img class="close" src="@/assets/img/icon-close-black.svg" alt="close" @click.stop="handleClose">

        <div class="subtitle">Rent Premium with your monthly subscription</div>
        <div class="title">Premiums Styles</div>
        <div class="text">
          <span v-for="(item, index) in premiumTextArr" :key="index">{{item}}</span>
        </div>
      </div>
    </Modal>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.modal-premium-introduce-mobile {
  .modal-premium-introduce {
    width: 100%;
    background: linear-gradient(180deg, #F1E8E4 0%, #FFF 32.05%);
    position: relative;

    padding: 30px 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .close {
      position: absolute;
      right: 16px;
      top: 16px;
      cursor: pointer;
    }

    .subtitle {
      text-align: center;
      /* Eyebrow/small */
      font-family: "TWK Lausanne";
      font-size: 10px;
      font-style: normal;
      font-weight: 650;
      line-height: 12px; /* 120% */
      text-transform: uppercase;
    }

    .title {
      text-align: center;
      /* Headline/small */
      font-family: "Alternate Gothic No3 D";
      font-size: 22px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px; /* 133.333% */
      text-transform: uppercase;
    }

    .text {
      /* Text sm/Regular */
      font-family: "TWK Lausanne";
      font-size: 14px;
      font-style: normal;
      font-weight: 300;
      line-height: 20px; /* 142.857% */

      white-space: break-spaces;

      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }
}

.modal-premium-introduce-desktop {
  .modal-premium-introduce {
    display: flex;
    width: 480px;
    padding: 20px 33px;
    flex-direction: column;
    align-items: flex-start;

    background: linear-gradient(180deg, #F1E8E4 0%, #FFF 32.05%);
    position: relative;

    .close {
      position: absolute;
      right: 16px;
      top: 16px;
      cursor: pointer;
    }

    .subtitle {
      /* Eyebrow/small */
      font-family: "TWK Lausanne";
      font-size: 10px;
      font-style: normal;
      font-weight: 650;
      line-height: 12px; /* 120% */
      text-transform: uppercase;
    }

    .title {
      /* Headline/small */
      font-family: "Alternate Gothic No3 D";
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px; /* 133.333% */
      text-transform: uppercase;
    }

    .text {
      margin-top: 14px;

      /* Text sm/Regular */
      font-family: "TWK Lausanne";
      font-size: 14px;
      font-style: normal;
      font-weight: 300;
      line-height: 20px; /* 142.857% */

      white-space: break-spaces;

      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }
}
</style>
